module.exports = __webpack_public_path__ + "img/repair-desk.deb20a1d.jpg";